module.exports = __webpack_public_path__ + "static/media/clients-04.40655779.svg";